import Styled, { css } from 'styled-components';

import { media } from '../../lib/StyledComponents';

import { IHeaderLinkProps } from './Common';

export const HeaderLinksContainer = Styled.ul`
  margin-left: auto;
  display: flex;
  flex: 1;
  justify-content: flex-end;
  align-content: center;
  align-items: center;
  height: 100%;

  a,
  button {
    text-decoration: none;
    color: ${({ theme: { header } }) => header.colorLink};

    &:hover {
      color: ${({ theme: { header } }) => header.colorLinkHover};
    }
  }

  > li {
    align-items: center;
    padding-right: 1em;
    height: 100%;
  }

  li:last-child {
    padding-right: 0;
  }

  ${media.medium`
    margin-left: auto;

    > li {
      padding-right: 1.5em;
    }
  `}
`;

export const HeaderDesktopOnlyLinkContainer = Styled.li<IHeaderLinkProps>`
  ${({ breakPoint = 'small' }) =>
    (css`
      display: none;

      ${media[breakPoint]`
        display: flex;
      `}
    `)
  }
`;

export const HeaderMobileOnlyLinkContainer = Styled.li<IHeaderLinkProps>`
  ${({ breakPoint = 'small' }) =>
    (css`
      display: flex;

      ${media[breakPoint]`
        display: none;
      `}
    `)
  }
`;
